module.exports = __webpack_public_path__ + "img/2_286.d25ca5c8.png";